import React from 'react'
import { Icon, IconProps } from '@chakra-ui/icons'

export const KeyboardIcon = (props: IconProps) => (
  <Icon viewBox="0 0 22 22" {...props}>
    <rect width="6" height="6" rx="1" fill="currentColor" />
    <rect y="8" width="6" height="6" rx="1" fill="currentColor" />
    <rect y="16" width="6" height="6" rx="1" fill="currentColor" />
    <rect x="8" width="6" height="6" rx="1" fill="currentColor" />
    <rect x="8" y="8" width="6" height="6" rx="1" fill="currentColor" />
    <rect x="8" y="16" width="6" height="6" rx="1" fill="currentColor" />
    <rect x="16" width="6" height="6" rx="1" fill="currentColor" />
    <rect x="16" y="8" width="6" height="6" rx="1" fill="currentColor" />
    <rect x="16" y="16" width="6" height="6" rx="1" fill="currentColor" />
  </Icon>
)
